import { Button, Distribute, FormField, Text, TextInput } from '@loomhq/lens';
import Mousetrap from 'mousetrap';
import React from 'react';
import { connect } from 'react-redux';

import { SHARE_VIDEO_PRIVACY_UPDATED } from 'constants/events';
import { ENTER, ESCAPE, KEY_ESCAPE } from 'constants/keyCodes';
import { KEY_UP } from 'constants/keyEvents';
import { updateVideoSettings } from 'creators/shareVideo';
import * as analytics from 'utilities/analytics';

import './styles.less';

class PrivacySettings extends React.Component {
  static defaultProps = {
    onCancelClick: () => {},
    onSaveClick: () => {},
  };

  state = {
    password: null,
    confirmPassword: null,
    error: null,
  };

  render() {
    const { video, validationError, onCancelClick } = this.props;

    if (video == null) {
      return null;
    }

    const { password, confirmPassword, error } = this.state;

    const errorMessage = validationError || error;

    return (
      <Distribute
        direction="column"
        className="px:xlarge pt:xlarge pb:large"
        alignment="stretch"
      >
        <Text variant="title">Add a password</Text>
        <div className="grow:1">
          <FormField
            label="Enter new password"
            labelFor="new-password"
            className="mt:medium"
          >
            <TextInput
              id="new-password"
              value={password || ''}
              type="password"
              onChange={e => this.handleUpdatePassword(e.target.value)}
              autoFocus={true}
              onKeyUp={e => this.handleOnKeyUp(e)}
              hasError={errorMessage}
            />
          </FormField>
          <FormField
            label="Confirm password"
            labelFor="confirm-password"
            className="mt:medium"
          >
            <TextInput
              id="confirm-password"
              autoFocus={false}
              value={confirmPassword || ''}
              type="password"
              onChange={e => this.handleUpdateConfirmPassword(e.target.value)}
              onKeyUp={e => this.handleOnKeyUp(e)}
              hasError={errorMessage}
            />
          </FormField>
          {errorMessage && (
            <div className="my:small">
              <Text color="red">{errorMessage}</Text>
            </div>
          )}
        </div>
        <div className="mt:medium">
          <Distribute isSpread>
            <Button variant="neutral" onClick={onCancelClick}>
              Cancel
            </Button>
            <Button
              isDisabled={
                !password || errorMessage || password !== confirmPassword
              }
              onClick={() => this.handleSaveClick()}
              variant="primary"
            >
              Save
            </Button>
          </Distribute>
        </div>
      </Distribute>
    );
  }

  componentDidMount() {
    Mousetrap.bind(KEY_ESCAPE, this.props.onCancelClick, KEY_UP);
  }

  componentWillUnmount() {
    Mousetrap.unbind(KEY_ESCAPE, KEY_UP);
  }

  handleUpdateConfirmPassword = confirmPassword => {
    this.setState({ confirmPassword });
  };

  handleUpdatePassword = password => {
    this.setState({ password });
  };

  handleOnKeyUp = e => {
    if (e.keyCode === ENTER) {
      this.handleSaveClick();
    } else if (e.keyCode === ESCAPE) {
      this.props.onCancelClick();
    }

    if (
      this.state.error &&
      this.state.password === this.state.confirmPassword
    ) {
      this.setState({ error: null });
    }
  };

  handleSaveClick = () => {
    const { password, confirmPassword } = this.state;
    const { onSaveClick, video, updateVideoSettings } = this.props;

    if (password !== confirmPassword) {
      this.setState({ error: 'The passwords do not match.' });

      return;
    }

    let pwd; // default to not changing password setting

    if ((password || '').length > 0) {
      // Only change password if user entered a new one (ie. length > 0)
      pwd = password;
    }

    if (pwd !== undefined) {
      analytics.track(SHARE_VIDEO_PRIVACY_UPDATED, {
        action:
          !video.is_protected && (password || '').length > 0
            ? 'added'
            : 'changed',
        video_id: video.id,
      });

      updateVideoSettings({}, pwd);
    }

    onSaveClick();
  };
}

const mapStateToProps = state => {
  const {
    settings_modal_err: validationError,
    show_pw_settings_modal: show,
    video,
  } = state.share_video;

  return {
    show,
    validationError,
    video,
  };
};

const mapDispatchToProps = dispatch => ({
  updateVideoSettings: (newSettings, password) =>
    dispatch(updateVideoSettings(newSettings, password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrivacySettings);
